import { render, staticRenderFns } from "./CarManage.vue?vue&type=template&id=70d72f42&scoped=true&"
import script from "./CarManage.vue?vue&type=script&lang=js&"
export * from "./CarManage.vue?vue&type=script&lang=js&"
import style0 from "./CarManage.vue?vue&type=style&index=0&id=70d72f42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d72f42",
  null
  
)

export default component.exports